import ContractInvitationsHeader from "./ContractInvitationsHeader";

export default ContractInvitationsHeader;
